import { AuthenticationFactors } from '../../interfaces/AuthenticationFactors';
import { AuthenticationFactorsDto } from '../../interfaces/Dto/AuthenticationFactorsDto';

export default function transformAuthenticationFactors(authenticationFactorsDto: AuthenticationFactorsDto): AuthenticationFactors {
  const result = {
    data: authenticationFactorsDto?.data?.map((x) => ({
      type: x.type,
      provider: x.provider,
      typeLabel: x.typeLabel,
      information: x.information,
    })),
    behaviours: authenticationFactorsDto ? { introductionText: authenticationFactorsDto.behaviours.introductionText }
      : undefined,
  };
  return result;
}
